<template>
  <carousel :itemsToShow="1.3" :autoplay="3000" :mouse-drag="true" :wrap-around="true" :navigation-enabled="true">
    <slide v-for="(photo, index) in islandDetail.photos" :key="index">
      <div class="carousel-slide">
      <!--
        <img :src="base + '/pub' + photo.path" alt="Image slide" class="carousel-image"/>
      -->
        <img :src="photo.path" :alt="photo.alt" class="carousel-image"/>
        <div class="overlay-text" v-if="photo.location || photo.copyright">
          <div class="location" v-if="photo.location">{{ photo.location }}</div>
          <div class="copyright" v-if="photo.copyright">{{ photo.copyright }}</div>
        </div>
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import { mapState } from 'vuex';

export default {
  components: {
    Carousel,
    Slide
  },
  props: {
    islandDetail: {
      type: Object,
      required: true,
      default: () => ({
        photos: []
      })
    }
  },
  // data() {
  //   return {
  //     images: [
  //       '/photo01.jpg',
  //       '/photo02.jpg',
  //       '/photo03.jpg',
  //       '/photo04.jpg'
  //     ]
  //   };
  // },
  computed: {
    // ...mapGetters('island', { base: this.base }) // Vuexからbaseを取得
    ...mapState('base',{
      // base: (state) => state.baseModule.base || ''  // baseModuleというモジュールからbaseを取得
      base: (state) => state.base
    }),
    computedBase() {
      return this.base || '';  // baseがundefinedの場合に空文字を返す
    }
  },
  created() {
    // baseが正しく取得されているかコンソールで確認
    // console.log('SwiperView.vue - base:', this.base);
    // if (!this.base) {
    if (!this.computedBase) {
      console.warn('base is empty on created, waiting for update...');
      // Vuexのstoreが更新されるのを待つ
      this.$watch('base', (newBase) => {
      // this.$watch('computedBase', (newBase) => {
        console.log('SwiperView.vue - base updated to:', newBase);
      });
    }
  },
};
</script>

<style>
.carousel-slide {
  position: relative;
}
.carousel-image {
  width: 100%;
  height: auto;
  max-height: 600px;
  object-fit: cover;
}
.overlay-text {
  position: absolute;
  bottom: 10px;
  right: 10px;
  /* テキストのスタイルを調整 */
  color: rgba(255, 255, 255, 0.8); /* 白色で80%の不透明度 */
  background-color: rgba(0, 0, 0, 0.4); /* 背景を黒の40%不透明度で半透明に */
  padding: 4px 8px;
  border-radius: 4px;
  line-height: 1.2;
}
.overlay-text .location {
  font-size: 13px;
}
/*
.overlay-text .location .title{
  font-size: 9px;
  margin-right: 4px;
}
*/
.overlay-text .copyright {
  font-size: 8px;
}
.overlay-text .copyright::before {
  /*
  content:" copyright:"
  */
}
.vue3-carousel__prev,
.vue3-carousel__next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
}

.vue3-carousel__prev {
  left: 10px;
}

.vue3-carousel__next {
  right: 10px;
}
</style>